import { useMemo } from 'react';

import { Message } from 'primereact/message';

import { useShipmentContext } from '../../hooks/useShipmentContext';

export function ShipmentNotifications() {
  const { shipment, calves, donors, embryos, recipients, semen } =
    useShipmentContext();

  const messages = useMemo(() => {
    const msgs: React.ComponentProps<typeof Message>[] = [];

    if (!shipment) {
      return msgs;
    }

    const hasEmbryos = embryos.length > 0;
    if (
      (shipment.hasEmbryos && !hasEmbryos) ||
      (!shipment.hasEmbryos && hasEmbryos)
    ) {
      msgs.push({
        severity: 'warn',
        text: 'Shipment has mismatched embryos. Please check the shipment details.',
      });
    }

    const hasSemen = semen.length > 0;
    if ((shipment.hasSemen && !hasSemen) || (!shipment.hasSemen && hasSemen)) {
      msgs.push({
        severity: 'warn',
        text: 'Shipment has mismatched semen. Please check the shipment details.',
      });
    }

    const hasDonors = donors.length > 0;
    if (
      (shipment.hasDonors && !hasDonors) ||
      (!shipment.hasDonors && hasDonors)
    ) {
      msgs.push({
        severity: 'warn',
        text: 'Shipment has mismatched donors. Please check the shipment details.',
      });
    }

    const hasRecipients = recipients.length > 0;
    if (
      (shipment.hasRecipients && !hasRecipients) ||
      (!shipment.hasRecipients && hasRecipients)
    ) {
      msgs.push({
        severity: 'warn',
        text: 'Shipment has mismatched recipients. Please check the shipment details.',
      });
    }

    const hasCalves = calves.length > 0;
    if (
      (shipment.hasCalves && !hasCalves) ||
      (!shipment.hasCalves && hasCalves)
    ) {
      msgs.push({
        severity: 'warn',
        text: 'Shipment has mismatched calves. Please check the shipment details.',
      });
    }

    return msgs;
  }, [shipment, embryos, semen, donors, recipients, calves]);

  return messages.map((msg, index) => (
    <Message
      key={index}
      severity={msg.severity}
      text={msg.text}
      className="w-full justify-start px-8 py-4"
    />
  ));
}
